import { create } from 'zustand';

export const useStrategyStore = create((set) => ({
  strategies: [],
  selectedStrategy: null,
  loading: false,
  error: null,

  setStrategies: (strategies) => set({ strategies }),
  setSelectedStrategy: (strategy) => set({ selectedStrategy: strategy }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),

  addStrategy: (strategy) =>
    set((state) => ({
      strategies: [...state.strategies, strategy],
    })),

  updateStrategy: (id, data) =>
    set((state) => ({
      strategies: state.strategies.map((s) =>
        s.id === id ? { ...s, ...data } : s
      ),
    })),

  deleteStrategy: (id) =>
    set((state) => ({
      strategies: state.strategies.filter((s) => s.id !== id),
    })),
}));

export const useSignalStore = create((set) => ({
  signals: [],
  loading: false,
  error: null,

  setSignals: (signals) => set({ signals }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),

  addSignal: (signal) =>
    set((state) => ({
      signals: [signal, ...state.signals],
    })),
}));

export const useStockStore = create((set) => ({
  stocks: {},
  loading: false,
  error: null,

  setStocks: (stocks) => set({ stocks }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),

  updateStock: (symbol, data) =>
    set((state) => ({
      stocks: {
        ...state.stocks,
        [symbol]: { ...(state.stocks[symbol] || {}), ...data },
      },
    })),
}));
